import { getLink, trans } from "~/providers/lang";
import GalleryEnter from "~/components/GalleryEnter";
import { ROUTES, GALLERY_PREVIEW_LARGE_COUNT } from '~/const';
import { useSeo } from "~/hooks/useSeo";
import { mainStore } from "~/stores/main";

import "./style.less";

export default function ActionPage() {
	useSeo({
		title: trans("skelet.title.action"),
		canonical: "akce",
	});

	const pageData = mainStore(state => state.data.pageData);
	const items = pageData.photos.action[0].slice(0, GALLERY_PREVIEW_LARGE_COUNT);

	return <div className="body-background">
		<div className="action-page page-content top-shadow">
			<h1 className="other-page-title">
				{trans('action.title')}
			</h1>
			<div className="row">
				<div className="col-md-12">
					<p className="desc center">
						{trans('action.desc')}
					</p>
				</div>
			</div>
			<GalleryEnter link={getLink(ROUTES.galleryAction)} items={items} />
		</div>
	</div>;
}
